import {IStateService} from 'angular-ui-router';
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import {TSDocumentType} from '../../../models/enums/TSDokumentType';
import TSVorleistung from '../../../models/TSVorleistung';
import TSVorleistungDaten from '../../../models/TSVorleistungDaten';
import DVBernUtil from '../../../utils/DVBernUtil';
import {IVorleistungStateParams} from '../../gesuch.route';
import AbstractModelManagerController from '../abstractModelManagerController';

declare let require: any;
declare let angular: any;

import IComponentOptions = angular.IComponentOptions;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;
import {TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';

let styles = require('./vorleistungView.scss');
let template = require('./vorleistungView.html');

export class VorleistungEditViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = VorleistungViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        vorleistung: '<',
        schadenfallId: '<',
        schaetzung: '<',
    };
}

export class VorleistungViewController extends AbstractModelManagerController<TSVorleistung> {

    vorleistung: TSVorleistung;
    form: IFormController;
    schadenfallId: string;
    doctype: TSDocumentType = TSDocumentType.VORLEISTUNG_DOC;
    schaetzung: boolean;

    static $inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state'];

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil, schadenfallModelManager: SchadenfallModelManager,
                private $q: IQService,
                $scope: IScope, private $translate: ITranslateService, private $log: ILogService,
                private $state: IStateService, private $stateParams: IVorleistungStateParams,
    ) {
        super(schadenfallModelManager, $scope, $state.current.name);

    }

    $onInit() {

        super.$onInit();
        if (this.vorleistung) {
            this.initialModel = this.vorleistung;
            this.model = angular.copy(this.vorleistung);
        } else {
            this.vorleistung = new TSVorleistung();
            this.vorleistung.schaetzung = this.schaetzung;
            this.vorleistung.vorleistungDatenFS = new TSVorleistungDaten();
            this.$log.warn('initialized vorleistung to edit directly in view, should pass vorleistung to edit along');
        }
    }

    public saveVorleistung() {
        if (this.isModelValid() && this.vorleistung) {
            this.schadenfallModelManager.saveVorleistung(this.getModel()).then((result: any) => {
                this.navigateAway();
            });
        } else {
            this.$log.debug('Form was not valid');
        }
    }

    public cancelVorleistung() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.navigateAway();
    }

    private navigateAway() {
        const nextPage = this.schaetzung ? 'schaetzung' : 'aufwaende';
        this.$state.go(nextPage, {schadenfallId: this.schadenfallId});
    }

    public isVorleistungReadonly() {
        //FIXME FS-706 temporary hack. Solve with separate view
        return (this.schaetzung &&
            !(this.schadenfallModelManager.isSchadenfallStatus(TSSchadenfallStatus.AUFTRAG_SCHAETZER) ||
                this.schadenfallModelManager.isSchadenfallStatus(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE)));
    }

}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/vorleistungView/vorleistungView.ts